import { AppError } from './AppError.js';
import { CombinedError } from 'urql';
import 'react';
import '@tanstack/react-query';
import 'lodash-es';

/**
 * Error thrown when we tried to look something up in the API, but it was
 * not found (i.e. returns null). Optionally provide the slug that was used
 * to do the lookup.
 */ class NotFoundError extends AppError {
    constructor(entityType, slug){
        super({
            title: `We can't find that ${entityType}`,
            message: `The ${entityType}${slug === undefined ? '' : ` ${slug}`} might not exist anymore,
        or there's a typo in the URL. Contact the owner for more information.
      `
        });
        Object.setPrototypeOf(this, NotFoundError.prototype);
    }
}
function isNotFoundError(error) {
    return error instanceof NotFoundError || error instanceof CombinedError && error.message.match(/\[GraphQL\] Resource.*not found/);
}

export { NotFoundError, isNotFoundError };
//# sourceMappingURL=NotFoundError.js.map
